export default "__VITE_ASSET__llaqeiIp__"